export class NotificationNames {
  static SIGN_IN = 'signInNotificationContent'
}
